"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMiniBag = void 0;
var ToggleMenuFlyout = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var _basketItem = require("@ori/basket-item");
var _shoppingContext = require("@ori/shopping-context");
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _react = require("react");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _logger = require("../logger");
var _useBreakpointIndex = require("./useBreakpointIndex");
var _useTranslations = require("./useTranslations");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
/* eslint-disable node/callback-return -- TODO: fix later */

const useMiniBag = ({
  useOpenedMinibagOnDesktop
}) => {
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const breakpointIndex = (0, _useBreakpointIndex.useBreakpointIndex)();
  const {
    isLoading,
    isLoaded,
    shoppingContext
  } = (0, _shoppingContext.useShoppingContext)();
  const {
    isMiniBagConfigurationLoading,
    miniBagConfiguration: {
      isBasketSharingEnabled = false
    } = {}
  } = (0, _contexts.useMiniBagConfiguration)();
  const {
    isAnonymous = false,
    isConsultant = false,
    showBp: showBpGlobally = false,
    shoppingBag: {
      shoppingBagItems = []
    } = {}
  } = shoppingContext ?? {};
  const {
    isDiscounted = false
  } = shoppingContext?.shoppingBag ?? {};
  const basketItemTranslations = {
    ..._basketItem.basketItemDefaultTranslations,
    ...translations
  };
  const basketItemTranslationsNamespace = _constants.translationsNamespace;
  const items = shoppingBagItems.filter(item => item.itemType !== 'U');
  const [isVisible, setIsVisible] = (0, _react.useState)(false);
  const [lastCallback, setLastCallback] = (0, _react.useState)(undefined);
  const setCallback = (0, _react.useCallback)(callback => setLastCallback(oldCallback => {
    if (oldCallback) {
      (0, _logger.logDebug)('cancelling old callback ...');
      oldCallback.cancel();
    }
    (0, _logger.logDebug)('setting up toggle menu callback:', callback);
    callback?.();
    return callback;
  }), []);
  (0, _logger.logDebug)('Rendering ...\n\t current state:', {
    shoppingContext,
    breakpointIndex,
    isVisible,
    lastCallback,
    useOpenedMinibagOnDesktop
  });
  const isOpenedMinibagOnDesktop = useOpenedMinibagOnDesktop && breakpointIndex === 2;
  const isOtherPageSmallScreen = !useOpenedMinibagOnDesktop && breakpointIndex === 0;
  const debouncedHide = (0, _react.useCallback)(() => (0, _lodash.default)(() => {
    setCallback(undefined);
    setIsVisible(false);
  }, 500), [setCallback, setIsVisible]);
  const toggleMenuCallback = (0, _react.useCallback)(data => {
    (0, _logger.logDebug)('toggleMenuCallback - event:', data);
    if (isOpenedMinibagOnDesktop || isOtherPageSmallScreen) {
      (0, _logger.logDebug)('toggleMenuCallback: ignored in this breakpoint');
      return undefined;
    }
    if (data.detail.menuType !== ToggleMenuFlyout.MenuTypes.Minibag) {
      (0, _logger.logDebug)('toggleMenuCallback: toggle-menu-flyout event for another component, closing ...');
      setIsVisible(false);
      return undefined;
    }
    if (typeof data.detail.shouldOpen === 'undefined') {
      (0, _logger.logDebug)('toggleMenuCallback: toggle-menu-flyout event without shouldOpen property set,', 'toggling visibility ...');
      setIsVisible(previousState => !previousState);
      return undefined;
    }
    if (data.detail.shouldOpen) {
      (0, _logger.logDebug)('toggleMenuCallback: toggle-menu-flyout event with shouldOpen === true, opening ...');
      setIsVisible(true);
      return undefined;
    }
    (0, _logger.logDebug)('toggleMenuCallback: toggle-menu-flyout event with shouldOpen === false', 'closing scheduled after 500 ms ...');
    return debouncedHide();
  }, [debouncedHide, isOpenedMinibagOnDesktop, isOtherPageSmallScreen, setIsVisible]);
  (0, _react.useEffect)(() => {
    // always show in eCatalog "desktop" mode
    if (isOpenedMinibagOnDesktop) {
      (0, _logger.logDebug)('useOpenedMinibagOnDesktop - always shown: opening ...');
      setIsVisible(true);
    }
    // always hide in other pages small screen
    if (isOtherPageSmallScreen) {
      (0, _logger.logDebug)('other pages and small breakpoint - always hidden: closing ...');
      setIsVisible(false);
    }
    const toggleMenuFlyoutHandler = data => setCallback(toggleMenuCallback(data));
    window.addEventListener(ToggleMenuFlyout.Name, toggleMenuFlyoutHandler);
    return () => window.removeEventListener(ToggleMenuFlyout.Name, toggleMenuFlyoutHandler);
  }, [breakpointIndex, isOpenedMinibagOnDesktop, isOtherPageSmallScreen, lastCallback, setCallback, setIsVisible, toggleMenuCallback, useOpenedMinibagOnDesktop]);
  const handleOverlayClick = () => {
    if (!isOpenedMinibagOnDesktop) {
      setIsVisible(false);
    }
  };
  const onMouseEnter = (0, _react.useCallback)(() => {
    if (useOpenedMinibagOnDesktop || isOtherPageSmallScreen) {
      (0, _logger.logDebug)('mouseenter: ignored in this breakpoint');
      return;
    }
    (0, _logger.logDebug)('mouseenter');
    setCallback(undefined);
  }, [useOpenedMinibagOnDesktop, isOtherPageSmallScreen, setCallback]);
  const onMouseLeave = (0, _react.useCallback)(() => {
    if (useOpenedMinibagOnDesktop || isOtherPageSmallScreen) {
      (0, _logger.logDebug)('mouseleave: ignored in this breakpoint');
      return;
    }
    (0, _logger.logDebug)('mouseleave: hiding ...');
    setIsVisible(false);
  }, [useOpenedMinibagOnDesktop, isOtherPageSmallScreen, setIsVisible]);
  const ownerState = {
    breakpointIndex,
    isOpenedMinibagOnDesktop,
    isVisible,
    useOpenedMinibagOnDesktop
  };
  const minibagProps = {
    breakpointIndex,
    isBasketSharingEnabled: isBasketSharingEnabled && isLoaded && isAnonymous,
    isDataLoaded: isLoaded,
    useOpenedMinibagOnDesktop,
    isLoading: isLoading || isMiniBagConfigurationLoading,
    items,
    isConsultant,
    showBpGlobally,
    isDiscounted,
    basketItemTranslations,
    basketItemTranslationsNamespace,
    onMouseEnter,
    onMouseLeave
  };
  return {
    isOpenedMinibagOnDesktop,
    isVisible,
    handleOverlayClick,
    minibagProps,
    ownerState
  };
};
exports.useMiniBag = useMiniBag;